<script>
// api
import { getPromotionList } from '~/api/classical.api'
import { saveCustomerOrderManager, saveBrowsingHistory } from '~/api/common.api'
import { searchProjectListByCompanyId } from '~/api/project.api'
// component
import CustomerRatings from '~/components/CustomerRatings'
import DecorationQuotation from '~/components/Base/DecorationQuotation'
import HomepageHeader from '~/components/Homepage/HomepageHeader' // not match
import HomepageDescription from '~/components/Homepage/HomepageDescription'
import HomepageContent from '~/components/Homepage/HomepageContent'
import HomepageService from '~/components/Homepage/HomepageService'
import HomepageList from '~/components/Homepage/HomepageList'
import HomepageQuotation from '~/components/Homepage/HomepageQuotation'
import HomepageQualification from '~/components/Homepage/HomepageQualification' // not match
import HomepageShow from '~/components/Homepage/HomepageShow'

// constant
import yqzConstant from '~/constant/target-type.constant'
export default {
  head() {
    const url = process.env.ONLINE_URL + this.$route.path
    const title = `${this.company.shortName}-电话,地址,工地,报价,评价怎么样-${this.companyCity}装修公司`
    const desc = this.company.brief
      ? this.company.brief.slice(0, 99)
      : `${this.company.shortName}装修效果图如何？${this.company.shortName}装修工地怎么样？${this.company.shortName}口碑评价好不好？${this.company.shortName}电话,地址是什么？了解${this.company.shortName}更多详细信息，让您家装修省心省力。`
    const location = `province=${this.companyProvince};city=${this.companyCity}`

    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: `${this.companyCity}装修,${this.companyCity}装修公司,${this.company.shortName}装修工地,${this.company.shortName}口碑评价,${this.company.shortName}怎么样`
        },
        {
          name: 'description',
          content: desc
        },
        {
          name: 'og:url',
          content: url
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'og:description',
          content: desc
        },
        {
          name: 'location',
          content: location
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: url
        }
      ]
    }
  },
  components: {
    CustomerRatings,
    DecorationQuotation,
    HomepageContent,
    HomepageDescription,
    HomepageHeader,
    HomepageList,
    HomepageShow,
    HomepageQuotation,
    HomepageService,
    HomepageQualification
  },
  data() {
    return {
      dialogVisible: false,
      width: ''
    }
  },
  async asyncData(context) {
    const {
      company,
      province: companyProvince,
      city: companyCity,
      techSupport
    } = context.store.state.company
    const companyId = company.companyId
    // 直播工地列表,使用oss裁剪封面
    const projectList = await getProjectList(companyId)
    // 获取三个公开的促销
    const promotionList = await getPromotionList({
      companyId,
      pageSize: 3,
      pageNo: 1,
      isShow: 'Y'
    })
    const promotionFaceList = promotionList.map((item) => {
      return {
        url: item.faceImgOssUrl,
        targetId: item.classicalProjectId
      }
    })
    return {
      companyId,
      company,
      companyProvince,
      companyCity,
      techSupport,
      promotionFaceList,
      projectList
    }
  },
  created() {
    if (this.$_thebox.clientWidth > 1250) {
      this.width = 1250 * 0.8 - 210
    } else if (this.$_thebox.clientWidth > 940) {
      this.width = (this.$_thebox.clientWidth - 100) * 0.8 - 180
    } else {
      this.width = this.$_thebox.clientWidth - 100
    }
  },
  beforeMount() {
    saveBrowsingHistory({
      targetId: this.companyId,
      companyId: this.companyId,
      targetType: yqzConstant.COMPANY
    })
  },
  methods: {
    // 点击获取报价
    onClickQuotation,
    // 点击提交预约
    onClickSubmit
  }
}
async function onClickQuotation(mobile) {
  const res = await saveCustomerOrderManager({
    mobile,
    targetType: yqzConstant.COMPANY,
    target: this.company.companyId,
    entryPoint: 'customerService_1',
    serviceName: '装修报价',
    landingPageId: 1,
    companyId: this.company.companyId,
    customer_app: 6,
    landing_page_id: 1
  })
  this.$notify({
    message: res.msg,
    type: res.judge ? 'success' : 'warning',
    duration: 3000
  })
}
async function onClickSubmit(mobile) {
  console.log('yqzConstant', yqzConstant)
  const res = await saveCustomerOrderManager({
    mobile,
    targetType: yqzConstant.COMPANY,
    target: this.company.companyId,
    entryPoint: 'homePage_1 ',
    serviceName: '免费预约',
    landingPageId: 3,
    companyId: this.company.companyId
  })
  this.$notify({
    message: res.msg,
    type: res.judge ? 'success' : 'warning',
    duration: 3000
  })
  this.dialogVisible = false
}

async function getProjectList(companyId) {
  const res = await searchProjectListByCompanyId({
    sort: 1,
    pageNo: 1,
    pageSize: 6,
    companyId,
    isdisplay: 'N'
  })
  const projectList = res.projectList
  return projectList
}
</script>
<template>
  <div style="background:rgba(239, 241, 242, 1);">
    <div class="home_page">
      <div v-if="promotionFaceList.length > 0" class="homepage_header">
        <HomepageHeader
          :img-list="promotionFaceList"
          :company-id="company.companyId"
        />
      </div>
      <div class="homepage_con_res">
        <div class="homepage_content">
          <HomepageContent :company="company" />
        </div>
        <div class="vertical_line_placeholder hide_on_mobile" />
        <div class="homepage_reservation hide_on_mobile">
          <DecorationQuotation @click-quotation="dialogVisible = true"
            >免费预约</DecorationQuotation
          >
        </div>
      </div>
      <div class="homepage_service">
        <h3 class="pc_owner_mod_header hide_on_pc">商户服务</h3>
        <HomepageService
          :company-name="company.shortName"
          :company-id="company.companyId"
        />
      </div>
      <!-- service之后的模块 -->
      <div class="homepage_bottom">
        <div class="bottom_left">
          <div class="homepage_list">
            <div class="list_title_container">
              <h3 class="pc_owner_mod_header">
                {{ `工地直播(${company.workingProjectNum})` }}
              </h3>
              <div class="list_more">
                <nuxt-link
                  :to="`/company/${companyId}/project`"
                  :target="$_newtab"
                >
                  查看更多
                  <img src="~/assets/image/icon/icon-arrow.png" />
                </nuxt-link>
              </div>
            </div>
            <HomepageList :project-list.sync="projectList" />
          </div>
          <div v-if="company.evaluateCount != 0" class="homepage_ratings">
            <h3 class="pc_owner_mod_header">
              {{ `业主评价(${company.evaluateCount})` }}
            </h3>
            <CustomerRatings :sum="company.evaluateCount" :width="width" />
          </div>
          <div
            v-if="company.brief"
            class="homepage_description_mobile hide_on_pc"
          >
            <h3 class="pc_owner_mod_header">公司简介</h3>
            <HomepageDescription :textarea="company.brief" />
          </div>
          <div
            v-if="company.qualOssUrl.length != 0"
            class="homepage_qualification"
          >
            <h3 class="pc_owner_mod_header">公司资质</h3>
            <HomepageQualification :img-list="company.qualOssUrl" />
          </div>
          <div v-if="company.styleOssUrl.length != 0" class="homepage_show">
            <h3 class="pc_owner_mod_header">公司展示</h3>
            <HomepageShow :img-list="company.styleOssUrl" />
          </div>
          <div class="homepage_footer_mobile hide_on_pc">
            <a :href="techSupport.link">{{ techSupport.description }}</a>
          </div>
        </div>
        <div class="bottom_right hide_on_mobile">
          <div v-if="company.brief" class="homepage_description">
            <div class="description_title">
              <h3 class="pc_owner_mod_header" style="font-size:18px;">
                公司简介
              </h3>
            </div>
            <div style="padding:0 20px;">
              <HomepageDescription :textarea="company.brief" />
            </div>
          </div>
          <div class="homepage_quotation">
            <HomepageQuotation
              :title="company.shortName"
              @click-quotation="onClickQuotation"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 预约弹窗 -->
    <QuotationDialog
      :visible.sync="dialogVisible"
      :title="`${company.shortName}为你免费预约`"
      :content="
        '欢迎咨询各类家装问题，竭诚为你服务。稍后客服会电话联系你，沟通具体的服务流程'
      "
      :button-text="'立即免费预约'"
      @click-submit="onClickSubmit"
    />
    <div class="decoration_quotation_mobile hide_on_pc">
      <DecorationQuotation @click-quotation="dialogVisible = true"
        >免费预约</DecorationQuotation
      >
    </div>
    <div class="project_footer hide_on_mobile">
      <a :href="techSupport.link">{{ techSupport.description }}</a>
    </div>
  </div>
</template>
<style lang="scss">
$border_1px: 1px solid rgba(239, 241, 242, 1);
$border_10px: 10px solid rgba(239, 241, 242, 1);
$border_20px: 20px solid rgba(239, 241, 242, 1);

.home_page {
  margin: 0 auto;
  > div {
    border-bottom: $border_20px;
    background: white;
  }

  .homepage_header {
    // border-bottom: none;
  }
  .homepage_con_res {
    display: flex;
    align-items: center;
  }
  .homepage_bottom {
    display: flex;
    .homepage_list {
      .list_title_container {
        display: flex;
        justify-content: space-between;
        .list_more {
          display: flex;
          margin-right: 15px;
          a {
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(155, 155, 155, 1);
            line-height: 12px;
            img {
              width: 6px;
              height: 10px;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1250px) {
  .home_page {
    max-width: 1150px;
  }
}

@media screen and (min-width: 940px) and (max-width: 1250px) {
  .home_page {
    margin: 0 50px;
  }
}

//仅在pc下
@media screen and (min-width: 940px) {
  .home_page {
    // margin: 0 50px;
    // max-width: 1150px;
    background: inherit;
    > div {
      // padding: 30px;
    }
    .homepage_header {
      padding: 0;
    }
    .homepage_con_res {
      height: 270px;
      .homepage_content {
        flex-basis: 65%;
        padding-left: 30px;
      }
      .vertical_line_placeholder {
        height: 80%;
        width: 1px;
        background: rgba(239, 241, 242, 1);
      }
      .homepage_reservation {
        flex-basis: 35%;
        padding: 95px 65px 0 75px;
        height: 100%;
      }
    }
    .homepage_list {
      .list_title_container {
        > h3 {
          margin-bottom: 25px;
        }
      }
    }
    .homepage_bottom {
      .bottom_left {
        background: $background_color;
        border-right: $border_20px;
        width: 80%;
        > div {
          background: white;

          border-bottom: $border_20px;
          padding: 30px 15px 30px 30px;
          > h3 {
            margin-bottom: 25px;
          }
        }
        .homepage_list {
          padding: 30px 15px 0px 30px;
        }
        .homepage_qualification {
          padding: 30px 30px 30px 30px;
        }
        .homepage_show {
          padding: 30px 30px 30px 30px;
        }
        .homepage_ratings {
          padding-right: 30px;
        }
      }
      .bottom_right {
        width: 20%;
        background: rgba(239, 241, 242, 1);
        .homepage_description {
          background: white;
          padding: 20px 0;
          margin-bottom: 20px;
          .description_title {
            height: 37px;
            margin-bottom: 10px;
            padding: 0 20px;
            border-bottom: $border_1px;
          }
        }
        .homepage_quotation {
          position: sticky;
          top: 0;
          background: white;
          padding: 20px;
        }
      }
    }
  }
  .project_footer {
    width: 100%;
    height: 52px;
    background: rgba(247, 247, 247, 1);
    text-align: center;
    position: relative;
    bottom: 0;
    a {
      font-size: 12px;
      font-weight: 600;
      color: rgba(155, 155, 155, 1);
      line-height: 52px;
    }
  }
}

//仅在mobile下
@media screen and (max-width: 940px) {
  .home_page {
    background: white;
    > div {
      border-bottom: $border_10px;
    }
    .homepage_header {
      border-bottom: none;
    }
    .homepage_con_res {
      .homepage_content {
        padding: 20px 15px;
      }
    }
    .homepage_service {
      padding: 20px 15px;
      > h3 {
        margin-bottom: 20px;
      }
    }
    .homepage_bottom {
      .bottom_left {
        width: 100%;
        > div {
          padding: 20px 0px 20px 15px;
          border-bottom: $border_10px;
        }
        .homepage_ratings {
          padding-right: 15px;
        }
        .homepage_description_mobile {
          padding-right: 15px;
          .pc_owner_mod_header {
            font-size: 20px;
            line-height: 20px;
          }
          .homepage-description {
            p {
              font-size: 15px;
            }
          }
          > h3 {
            margin-bottom: 18px;
          }
        }
        .homepage_qualification {
          > h3 {
            margin-bottom: 18px;
          }
        }
        .homepage_show {
          border-bottom: 0px;
          > h3 {
            margin-bottom: 18px;
          }
        }
        .homepage_footer_mobile {
          display: block;
          height: 124px;
          background: rgba(239, 241, 242, 1);
          text-align: center;
          a {
            text-decoration: none;
            font-size: 12px;
            font-weight: 500;
            color: rgba(155, 155, 155, 1);
          }
        }
      }
    }
  }
  .decoration_quotation_mobile {
    background: white;
    padding: 14px 20px 19px;
    z-index: 99;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
  }
}
</style>
